module.exports = "/_next/static/images/black-bubble-171ae08289bd2b49a506d8ba2a94e6d7.png";